import axios, { AxiosRequestConfig } from "axios";
import { buscaFerramenta, todaFerramenta, updateFerramentaBusca } from "../types/ferramenta";

export const getFerramentas = async (
  token: string
): Promise<buscaFerramenta[]> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/ferramenta`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar ferramentas:", error);
    throw error;
  }
};

export const getFerramentaById = async (
  token: string,
  id: string
): Promise<todaFerramenta> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/ferramenta/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar ferramenta:", error);
    throw error;
  }
};

export const createFerramenta = async (
  token: string,
  ferramentaData: FormData
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/ferramenta`;
    const response = await axios.post(url, ferramentaData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar ferramenta:", error);
    throw error;
  }
};

export const updateFerramenta = async (
  token: string,
  id: string,
  ferramentaData: updateFerramentaBusca
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/ferramenta/${id}`;
    const response = await axios.put(url, ferramentaData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar ferramenta:", error);
    throw error;
  }
};

export const deleteFerramenta = async (token: string, id: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/ferramenta/${id}`;
    const response = await axios.delete(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao excluir ferramenta:", error);
    throw error;
  }
};

export const createGrupoFerramenta = async (
  token: string,
  idEmpresa: number,
  idFerramenta: number
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/grupoferramenta`;
    const response = await axios.post(
      url,
      {
        id_empresa: idEmpresa,
        id_ferramenta: idFerramenta,
      },
      config
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar ferramenta na empresa:", error);
    throw error;
  }
};
